import { css } from "styled-components";
export const PanelBorderStyling = css `
  box-sizing: border-box;
  border-radius: 6px;
  border: 1px solid #0f0000;
`;
